<template>
  <div class="calico-document-item-page">
    <div class="calico-file-item-container">
      <CalicoDocumentItem 
        :document="document" 
        @save="save" 
        @edit="edit"
        @cancel="cancel"
        @download="download"
        @delete="ondelete"
      />
    </div>
  </div>
</template>

<script lang="js">
import CalicoDocumentItem from '@/components/pattern/documentItem/index.vue'
export default {
  name: 'CalicoDocumentItemPage',
  components: {
    CalicoDocumentItem
  },
  data () {
    return {
        document: {
            name: "file-name.pdf",
            type: "pdf",
            size: 100,
            year: "2025",
            description: ""
        }
    }
  },
  methods: {
    save () {
        console.log("save!")
    },
    edit () {
        console.log("edit!")
    },
    cancel () {
        console.log("cancel!")
    },
    download () {
        console.log("download!")
    },
    ondelete () {
        console.log("ondelete!")
    }
  }
}
</script>
<style lang="scss">
.calico-document-item-page {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  .calico-file-item-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 600px;
  }
  .calico-file-item-container-2 {
    @include stack-space($space-large);
    @include inset-space($space-large);
    background: $color-neutral-darkest;
    width: 600px;
  }
}
</style>
